import BonusSaleReportPage from '../../../../shared/reportBonusSale/BonusSaleReportPage'
import {ReportBonusSaleConfig} from '../../../../shared/reportBonusSale/ReportBonusSaleConfig'

const config: ReportBonusSaleConfig = {
  reportsBaseUrl: '/api/kpi/reports',
  apiEndpoint: 'bonus-sale-items',
  exportEndpoint: 'bonus-sale-items/export',
  exportFileName: 'Relatorio_vendas_bonus_detalhado_kpi.xlsx',
  pageTitle: 'Relatório de Vendas Bonus Detalhado',
  breadcrumbPath: '/kpi/reports/reportBonusSaleDetail/list',
  navigationPath: '/kpi/reports/reportBonusSale/list',
  navigationPermission: 'kpi.bonus_sales',
  navigationLabel: 'Resumido',
  navigationIcon: 'menu',
  isKpi: true,
  showFranchiseFilter: true,
  showClientAlertIcons: false,
  showPaymentsChart: false,
  useSwalErrorHandling: true,
  authPermission: 'kpi.bonus_sale_items',
  exportPermission: 'kpi.export',
  dateField: 'contractAt',
  reportType: 'detail',
}

const ReportBonusSaleDetailPage = () => <BonusSaleReportPage config={config} />

export default ReportBonusSaleDetailPage
